import React, { FC } from 'react'

import { IconGooglePlayWhiteProps } from './IconGooglePlayWhite.types'
import * as Styled from './styles/IconGooglePlayWhite.style'

import { nonThemeableRules } from '../../ruleSet'

const IconGooglePlayWhite: FC<IconGooglePlayWhiteProps> = ({
  size = nonThemeableRules.defaultSize as number as IconGooglePlayWhiteProps['size'],
  isResponsive = false,
}: IconGooglePlayWhiteProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M0 38.4c0-13.441 0-20.162 2.616-25.296A24 24 0 0 1 13.104 2.616C18.238 0 24.96 0 38.4 0h43.2c13.441 0 20.162 0 25.296 2.616a23.999 23.999 0 0 1 10.488 10.488C120 18.238 120 24.96 120 38.4v43.2c0 13.441 0 20.162-2.616 25.296a23.998 23.998 0 0 1-10.488 10.488C101.762 120 95.041 120 81.6 120H38.4c-13.441 0-20.162 0-25.296-2.616a23.999 23.999 0 0 1-10.488-10.488C0 101.762 0 95.041 0 81.6V38.4Z'
          fill='#fff'
        />
        <g clipPath='url(#624e3b89-9c3d-477d-81fd-845a438d2a86__a)'>
          <path
            d='M47.183 91.579c-2.02 0-3.666 1.536-3.666 3.652 0 2.104 1.646 3.652 3.666 3.652s3.666-1.55 3.666-3.652c0-2.116-1.646-3.652-3.666-3.652Zm0 5.866c-1.107 0-2.061-.914-2.061-2.214 0-1.314.954-2.214 2.061-2.214s2.061.9 2.061 2.214c0 1.301-.954 2.214-2.061 2.214Zm9.818-5.05h-.055c-.36-.43-1.052-.816-1.923-.816-1.827 0-3.501 1.605-3.501 3.666 0 2.048 1.674 3.64 3.5 3.64.872 0 1.564-.388 1.924-.83H57v.525c0 1.397-.747 2.144-1.951 2.144-.983 0-1.591-.706-1.84-1.3l-1.397.581c.4.969 1.466 2.159 3.237 2.159 1.882 0 3.473-1.107 3.473-3.805V91.8H57v.595Zm-1.84 5.05c-1.107 0-2.034-.928-2.034-2.2 0-1.286.927-2.228 2.034-2.228 1.093 0 1.951.94 1.951 2.228 0 1.273-.858 2.2-1.95 2.2Zm-15.977-5.866c-2.02 0-3.666 1.536-3.666 3.652 0 2.104 1.646 3.652 3.666 3.652s3.667-1.55 3.667-3.652c0-2.116-1.646-3.652-3.667-3.652Zm0 5.866c-1.106 0-2.06-.914-2.06-2.214 0-1.314.953-2.214 2.06-2.214 1.107 0 2.062.9 2.062 2.214 0 1.301-.955 2.214-2.062 2.214ZM29.67 92.7v1.55h3.709c-.11.87-.401 1.507-.845 1.95-.539.54-1.383 1.136-2.864 1.136-2.283 0-4.067-1.84-4.067-4.124 0-2.283 1.784-4.124 4.067-4.124 1.231 0 2.13.485 2.795 1.107l1.093-1.093c-.927-.885-2.158-1.563-3.888-1.563-3.127 0-5.756 2.546-5.756 5.673 0 3.127 2.63 5.672 5.756 5.672 1.689 0 2.96-.553 3.957-1.59 1.024-1.024 1.343-2.464 1.343-3.626 0-.36-.028-.692-.083-.969H29.67Zm38.913 1.204c-.305-.816-1.231-2.324-3.127-2.324-1.882 0-3.445 1.48-3.445 3.652 0 2.047 1.55 3.653 3.625 3.653 1.674 0 2.643-1.024 3.044-1.62l-1.245-.83c-.415.609-.983 1.01-1.799 1.01s-1.397-.374-1.77-1.107l4.884-2.02-.167-.414ZM63.6 95.12c-.041-1.412 1.093-2.13 1.909-2.13.636 0 1.176.317 1.355.774L63.6 95.12Zm-3.971 3.542h1.605V87.926H59.63v10.737ZM76.1 87.926h-3.84v10.737h1.602v-4.067h2.237c1.776 0 3.523-1.287 3.523-3.335s-1.746-3.335-3.522-3.335Zm.042 5.175h-2.28v-3.68h2.28c1.197 0 1.878.991 1.878 1.839 0 .833-.68 1.84-1.878 1.84Zm4.364 5.562h1.602V87.926h-1.602v10.737Zm5.539-7.104c-1.16 0-2.362.511-2.86 1.644l1.423.594c.304-.594.87-.787 1.465-.787.829 0 1.671.497 1.685 1.381v.11a3.547 3.547 0 0 0-1.671-.414c-1.533 0-3.094.843-3.094 2.417 0 1.437 1.258 2.362 2.666 2.362 1.078 0 1.671-.483 2.044-1.05h.055v.83h1.547v-4.117c0-1.906-1.423-2.97-3.26-2.97Zm-.194 5.885c-.525 0-1.257-.263-1.257-.912 0-.829.911-1.146 1.7-1.146.704 0 1.035.152 1.464.359a1.943 1.943 0 0 1-1.907 1.699Zm9.09-5.65-1.838 4.655h-.055l-1.906-4.655h-1.726l2.86 6.506-1.63 3.619h1.67l4.406-10.125h-1.781Z'
            fill='#000'
            opacity='.54'
          />
          <path
            d='M36.752 21.718c-.645.683-1.026 1.743-1.026 3.117v49.073c0 1.375.381 2.434 1.026 3.117l.165.16 27.49-27.49v-.648l-27.49-27.49-.165.16Z'
            fill='url(#624e3b89-9c3d-477d-81fd-845a438d2a86__b)'
          />
          <path
            d='m73.57 58.863-9.164-9.167v-.649l9.165-9.165.207.118 10.856 6.169c3.101 1.762 3.101 4.644 0 6.407l-10.856 6.17-.209.117Z'
            fill='url(#624e3b89-9c3d-477d-81fd-845a438d2a86__c)'
          />
          <path
            d='m73.778 58.744-9.372-9.373-27.654 27.654c1.023 1.082 2.71 1.216 4.612.136l32.414-18.417Z'
            fill='url(#624e3b89-9c3d-477d-81fd-845a438d2a86__d)'
          />
          <path
            d='M73.778 39.999 41.364 21.58c-1.902-1.08-3.589-.945-4.612.137L64.406 49.37 73.778 40Z'
            fill='url(#624e3b89-9c3d-477d-81fd-845a438d2a86__e)'
          />
          <path
            d='m73.571 58.538-32.207 18.3c-1.802 1.023-3.413.955-4.446.023l-.166.165.165.16c1.034.931 2.645 1 4.447-.025l32.414-18.417-.207-.206Z'
            fill='#000'
            opacity='.2'
          />
          <path
            d='M36.752 76.702c-.645-.683-1.026-1.743-1.026-3.117v.324c0 1.374.381 2.434 1.026 3.117l.166-.165-.166-.159Zm47.882-24.451-11.063 6.287.207.206 10.856-6.169c1.55-.88 2.326-2.042 2.326-3.202-.13 1.05-.92 2.08-2.326 2.878Z'
            fill='#000'
            opacity='.12'
          />
          <path
            d='m41.364 21.907 43.27 24.585c1.407.799 2.196 1.828 2.326 2.88.002-1.161-.774-2.323-2.326-3.204l-43.27-24.585c-3.101-1.762-5.638-.299-5.638 3.253v.324c0-3.552 2.537-5.015 5.638-3.253Z'
            fill='#fff'
            opacity='.25'
          />
        </g>
        <defs>
          <linearGradient
            id='624e3b89-9c3d-477d-81fd-845a438d2a86__b'
            gradientUnits='userSpaceOnUse'
            x1='61.969'
            x2='24.73'
            y1='24.317'
            y2='61.556'
          >
            <stop stopColor='#00A0FF' />
            <stop offset='.007' stopColor='#00A1FF' />
            <stop offset='.26' stopColor='#00BEFF' />
            <stop offset='.512' stopColor='#00D2FF' />
            <stop offset='.76' stopColor='#00DFFF' />
            <stop offset='1' stopColor='#00E3FF' />
          </linearGradient>
          <linearGradient
            id='624e3b89-9c3d-477d-81fd-845a438d2a86__c'
            gradientUnits='userSpaceOnUse'
            x1='88.672'
            x2='34.982'
            y1='49.373'
            y2='49.373'
          >
            <stop stopColor='#FFE000' />
            <stop offset='.409' stopColor='#FFBD00' />
            <stop offset='.775' stopColor='orange' />
            <stop offset='1' stopColor='#FF9C00' />
          </linearGradient>
          <linearGradient
            id='624e3b89-9c3d-477d-81fd-845a438d2a86__d'
            gradientUnits='userSpaceOnUse'
            x1='68.686'
            x2='18.188'
            y1='54.464'
            y2='104.962'
          >
            <stop stopColor='#FF3A44' />
            <stop offset='1' stopColor='#C31162' />
          </linearGradient>
          <linearGradient
            id='624e3b89-9c3d-477d-81fd-845a438d2a86__e'
            gradientUnits='userSpaceOnUse'
            x1='29.789'
            x2='52.339'
            y1='5.383'
            y2='27.932'
          >
            <stop stopColor='#32A071' />
            <stop offset='.069' stopColor='#2DA771' />
            <stop offset='.476' stopColor='#15CF74' />
            <stop offset='.801' stopColor='#06E775' />
            <stop offset='1' stopColor='#00F076' />
          </linearGradient>
          <clipPath id='624e3b89-9c3d-477d-81fd-845a438d2a86__a'>
            <path d='M0 0h100.524v105.496H0z' fill='#fff' transform='translate(10 7)' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconGooglePlayWhite
